import React from "react";
import { DA_FeatureHandler } from "../../../helpers/FeatureHandler.helper";
import { V1 } from "./v1/ProductListItemV1.component";

const featureName = "ProductListItemB2B";
const versions = {
    v1: V1,
};

// eslint-disable-next-line unused-imports/no-unused-vars
export const ProductListItemB2B = React.forwardRef(({ version, ...props }: any, ref: any) => (
    <DA_FeatureHandler
        featureName={featureName}
        featureVersions={versions}
        version={version}
        {...props}
    />
));

ProductListItemB2B.displayName = "ProductListItemB2B";
